import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
export function ModalFooter({ children, className }) {
    return (_jsx("div", { className: cn('flex p-stack-section w-full border-t border-border justify-end', className), children: children }));
}
